﻿import {translation} from "@2d-front-monorepo/core";
import {
	FullEntityRelation,
	RequiredVehicleProperties,
	VehicleId,
	VehicleResult
} from "@2d-front-monorepo/permits-business";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {JSX} from "react";
import {VehicleWithChangeComponent} from "./VehicleWithChange";

export function VehiclesComponent({vehicles, hiddenEntityProperties}: {
	vehicles: FullEntityRelation<VehicleId, VehicleResult>[],
	hiddenEntityProperties: RequiredVehicleProperties
}): JSX.Element | undefined {

	if (vehicles.length === 0) {
		return undefined;
	}

	return <div className="card card--vehicles">
		<header><h5>{translation(PermitTranslations.vehicles)}</h5></header>
		<hr className="no-margin"/>
		{vehicles.map(((x, i) =>
			<VehicleWithChangeComponent vehicle={x.original} hiddenEntityProperties={hiddenEntityProperties} changedVehicle={x.changed} key={i}/>
		))}
	</div>;
}
